export default function wrapAsyncCall(actions, func, payloadCreator = _.identity) {
  return (...args) => dispatch => {
    const payload = payloadCreator(...args);
    dispatch(actions.START(payload));
    return Promise.resolve(func(payload))
      .then(
        response => {
          dispatch(actions.SUCCESS(response));
          return response;
        },
        error => {
          dispatch(actions.FAIL(error));
          return Promise.reject(error);
        }
      );
  };
}



// WEBPACK FOOTER //
// ./src/shared/redux/helpers/wrap-async-call.js